export default {
  post: function(context) {
    context.$emit("apply-edits");
    if (!context.verifySync) {
      context.$store.dispatch("postEdits", context.filter);
    } else {
      context.$store.dispatch("addMessage", {
        text: "No edits detected.",
        type: "error",
        duration: 5000
      });
    }
  },
  arrangeListByLetter(list, letter) {
    return list
      .sort((item1, item2) => {
        var textA = item1.name.toUpperCase();
        var textB = item2.name.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      })
      .filter(prop => {
        return prop.name[0].toUpperCase() == letter.toUpperCase();
      });
  },
  alphabet: function() {
    return [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z"
    ];
  },
  beforeRouteLeave: function(context, to, from, next) {
    if (!context.$store.getters.verifySync) {
      context.$store
        .dispatch("postEdits")
        .then(() => {
          next();
        })
        .catch(() => {
          next(false);
        });
    } else {
      next();
    }
  },
  yearRange: function() {
    var range = [];
    var currentDate = new Date().getFullYear();
    for (var i = 0; i < 120; i++) {
      range.push(currentDate - i);
    }
    return range;
  }
};



// WEBPACK FOOTER //
// ./src/components/utils.js